// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"014ad0d1","37":"5e57ac66","512":"beed79d7","988":"35a2aa58"}[chunkId] + ".chunk.js";
};